import StartupScreen from './StartupScreen';

export default StartupScreen;
